import src from "IMAGE";
export default { src, width: 1446, height: 543, blurWidth: 0, blurHeight: 0};
